
import './index.less'
import React from 'react'
const te = ['none', 'dotted', 'groove', 'dashed', 'double']
console.log(React)
export default function BasicsTextCopy(props) {
  const obj = props.ifon.ifon.isFrame ? {
    paddingTop: props.ifon.ifon.framePaddingTop,
    paddingBottom: props.ifon.ifon.framePaddingBottom,
    paddingLeft: props.ifon.ifon.framePaddingLeft,
    paddingRight: props.ifon.ifon.framePaddingRight,
    borderStyle: te[props.ifon.ifon.textStyle],
    borderColor: props.ifon.ifon.frameColor,
    borderWidth: props.ifon.ifon.thickness,
    borderRadius: props.ifon.ifon.fillet
  } : {}

  return (<div className={`BasicsText`}
    style={{
      paddingTop: props.ifon.ifon.paddingTop,
      paddingBottom: props.ifon.ifon.paddingBottom,
      paddingLeft: props.ifon.ifon.paddingLeft,
      paddingRight: props.ifon.ifon.paddingRight,
      width: 375,
      border: '1px solid black',
      opacity: 0.5
    }}
  >
    <div className='BasicsText_seizeASeat' style={obj}>
      {!props.ifon.ifon.html ? '请在右侧中输入内容' : <div className='text' style={{
        color: props.ifon.ifon.color
      }} dangerouslySetInnerHTML={{ __html: props.ifon.ifon.html }}></div>}
    </div>
  </div>)
}
